import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import { fetchData, deleteData, activateData, updateData, SyncData, postData, DespatchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Tooltip } from '@mui/material';
import ArrowForward from '@mui/icons-material/ArrowForward';
import Select from 'react-select';
import { useParams, useHistory } from 'react-router-dom';
import Modal from '@mui/material/Modal';
import { FaHtml5, FaTimes } from 'react-icons/fa';
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import * as XLSX from 'xlsx';
import CircularProgress from '@mui/material/CircularProgress';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import TablePagination from '@mui/material/TablePagination';
import TableFooter from '@mui/material/TableFooter';

function RouteOrderlistReport() {
    const history = useHistory();
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [editedRouteSequenceNo, setEditedRouteSequenceNo] = useState(null);
    const [isFocused, setIsFocused] = useState(false);
    const [editItemId, setEditItemId] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);
    const [formData, setFormData] = useState();
    const [tripOptions, setTripOptions] = useState([]);
    const [selectedTrip, setSelectedTrip] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [tripDate, setTripDate] = useState('');
    const { isAuthenticated, companyId, userId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    const [saleOrderId, setSaleOrderId] = useState(false);
    const [showTable, setShowTable] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const [selectedCustomerData, setSelectedCustomerData] = useState(null);
    const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
        }
    }, [isAuthenticated, companyId, token, logout]);

    useEffect(() => {
        fetchTripTypes();
    }, []);

    const fetchTripTypes = async () => {
        try {
            const response = await fetchData('CustomerOrderedItemAPI', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(trip => ({
                    value: trip.Id,
                    label: trip.Description
                }));
                setTripOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };


    const [filteredData, setFilteredData] = useState([]);
    const [orderdate, setOrderdate] = useState("");
    const [orderTakenby, setOrdertakenby] = useState("");
    const [route, setroute] = useState("");

    const handleTripChange = async (selectedOption) => {
        setSelectedTrip(selectedOption);
        setData([]);

        try {
            const response = await fetchData('AddOrderAPI', `/${companyId}/${selectedOption.value}`, token);

            if (response.responseCode === '1111') {
                const dataArray = response.response_data;

                dataArray.forEach(item => { });
                setData(dataArray);
                if (dataArray.length > 0) {
                    setSaleOrderId(dataArray[0].id);
                    setOrderdate(dataArray[0].orderDate);
                    setOrdertakenby(dataArray[0].orderTakenBy);
                    setroute(dataArray[0].routeName);
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
            }
        } catch (error) {
            console.error('Error fetching Sale Details:', error);
        }
    };



    const handleHistoryClick = async (saleorderid) => {
        try {
            const response = await fetchData('VehicleApi', `/${companyId}/${saleorderid}`, token);
            if (response.responseCode === '1111') {
                setSelectedCustomerData(response.response_data);

                setShowModal(true);
            }
        } catch (error) {
            console.error('Error fetching Order Items:', error);
        }
    };

    const closeModal = () => {
        setShowModal(false);
    };
    // Use the function in your rendering logic
    let sortedData = moveGrandTotalToEnd(data);
    const [showSearchInput, setShowSearchInput] = useState(false);
    //handle search

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };
    //search
    const searchfilteredData = sortedData.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    function formatDate(dateString) {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
        return formattedDate;
    }

    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        printWindow.document.write('<html><head><title>Order Sorting List</title></head><body>');
        printWindow.document.write('<h3 style="font-family: Times New Roman; font-size: 32px;">Order Sorting List</h3>');

        // Check if there's data to display the common details
        if (data.length > 0) {
            const firstRow = data[0]; // Use the first row for common details
            printWindow.document.write('<div style="margin-bottom: 20px;">');
            printWindow.document.write(`<p style="font-size: 18px;">`);
            printWindow.document.write(`<strong>Route:</strong> ${firstRow.routeName || ''} &nbsp; | &nbsp; `);
            printWindow.document.write(`<strong>Order Taken by:</strong> ${firstRow.orderTakenBy || ''} &nbsp; | &nbsp; `);
            printWindow.document.write(`<strong>Order Date:</strong> ${formatDate(firstRow.orderDate)} &nbsp; | &nbsp; `);


            printWindow.document.write(`</p>`);
            printWindow.document.write('</div>');
        }

        printWindow.document.write('<table style="border-collapse: collapse; width: 100%;">');
        printWindow.document.write('<thead style="background-color: #f3f3f3;">');
        printWindow.document.write('<tr>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;"></th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Sl.No</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Product Category</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Item Code</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Item</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">UOM (Kgs)</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Quantity</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Bundle</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Pieces</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Total Quantity</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Active Customers</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Remarks</th>');
        printWindow.document.write('</tr>');
        printWindow.document.write('</thead>');
        printWindow.document.write('<tbody>');


        data.forEach((rowData, index) => {
            printWindow.document.write('<tr>');

            // Check if this OrderTypeName is the same as the previous row
            const showOrderTypeName = index === 0 || data[index - 1].OrderTypeName !== rowData.OrderTypeName;
            if (showOrderTypeName) {
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.OrderTypeName}</td>`);
            } else {
                printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px;"></td>');
            }

            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;text-align: center">${index + 1}</td>`);

            const showProductCategory = index === 0 || data[index - 1].productCategory !== rowData.productCategory;
            if (showProductCategory) {
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.productCategory}</td>`);
            } else {
                printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px;"></td>');
            }
            // printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.productCategory || ''}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.itemCode || ''}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.item || ''}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.kilogram || ''}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.quantity || ''}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.bundle || '0'}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.pieces || '0'}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.totalkilogram || ''}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.CustomerId || ''}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.saleremarks || ''}</td>`);
            printWindow.document.write('</tr>');
        });

        printWindow.document.write('</tbody></table></body></html>');
        printWindow.document.close();
        printWindow.print();
    };

    //excel

    const handleExportExcel = () => {
        const excelData = [];

        // Add a row for common details
        if (data.length > 0) {
            const firstRow = data[0]; // Get the first row for common details
            const commonDetailsRow = [
                'Route:', firstRow.routeName || '',
                'Order Taken by:', firstRow.orderTakenBy || '',
                'Order Date:', firstRow.orderDate ? new Date(firstRow.orderDate).toLocaleDateString('en-GB') : ''
            ];
            excelData.push(commonDetailsRow);
            // Add an empty row for spacing
            excelData.push([]);
        }

        // Add header row
        const headerRow = [
            '',
            'Sl.No',
            'Product Category',
            'Item Code',
            'Item',
            'UOM (Kgs)',
            'Quantity',
            'Bundle',
            'Pieces',
            'Total Quantity',
            'Active Customers',
            'Remarks'
        ];
        excelData.push(headerRow);


        // Add data rows
        data.forEach((rowData, index) => {
            // Check if this OrderTypeName is the same as the previous row
            const showOrderTypeName = index === 0 || data[index - 1].OrderTypeName !== rowData.OrderTypeName;
            const showProductCategory = index === 0 || data[index - 1].productCategory !== rowData.productCategory;

            const dataRow = [
                showOrderTypeName ? rowData.OrderTypeName : '', // Display only once for duplicates
                index + 1,
                showProductCategory ? rowData.productCategory : '',
                rowData.itemCode || '',
                rowData.item || '',
                rowData.kilogram || '',
                rowData.quantity || '',
                rowData.bundle || '0',
                rowData.pieces || '0',
                rowData.totalkilogram || '',
                rowData.CustomerId || '',
                rowData.saleremarks || ''
            ];
            excelData.push(dataRow);
        });

        // Create worksheet
        const ws = XLSX.utils.aoa_to_sheet(excelData);

        // Create workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Order Sorting List');

        // Save workbook to a file
        XLSX.writeFile(wb, 'Order Sorting List.xlsx');
    };

    const getRowColor = (balanceQty, weight) => {
        if (balanceQty <= weight / 2) {
            return { backgroundColor: '#FFD0D0' };
        }
        else if (balanceQty <= weight / 3) {
            return { backgroundColor: '#FFFFE0' };
        }
        else {
            return {}; // Default style
        }
    };

    const handleRefreshClick = () => {

        // setToDate(getCurrentDate());
        // fetchData();
        window.location.reload();
    };

    function moveGrandTotalToEnd(data) {
        let grandTotalRow;
        let filteredData = data.filter((item) => {
            if (item.ordertype === 'Grand Total') {
                grandTotalRow = item;
                return false;
            }
            return true;
        });

        if (grandTotalRow) {
            filteredData.push(grandTotalRow);
        }

        return filteredData;
    }

    const [page, setPage] = useState(0); // Current page
    const [rowsPerPage, setRowsPerPage] = useState(150); // Rows per page

    // Define initial column order
    const [columnOrder, setColumnOrder] = useState([
        'SL',
        '',
        'PDT Category',
        'Category',
        'Code',
        'Item',
        'UOM(kgs)',
        'Bundle',
        'Pieces',
        'QTY(No.Pieces)',
        'Total QTY(kgs)',
        'Active Customers',
        'Remarks'
    ]);
    // Process and paginate the data
    const processedData = searchfilteredData.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );


    // Handle page change
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    // Handle rows per page change
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to the first page
    };

    // Function to handle drag start
    const handleDragStart = (e, index) => {
        e.dataTransfer.setData('columnIndex', index);
    };

    // Function to handle drag over
    const handleDragOver = (e) => {
        e.preventDefault(); // Allow drop
    };
    // Function to handle drop
    const handleDrop = (e, index) => {
        const draggedIndex = e.dataTransfer.getData('columnIndex');
        if (draggedIndex !== index) {
            const newOrder = [...columnOrder];
            // Swap columns
            [newOrder[draggedIndex], newOrder[index]] = [newOrder[index], newOrder[draggedIndex]];
            setColumnOrder(newOrder);
        }
    };


    return (
        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>
            <h6 className="uppercase tracking-wide text-black flex-grow linkcolor"
                style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                Order Sorting List</h6>

            <div className="flex mb-2" style={{ marginTop: '-20px', marginLeft: '35%' }}>
                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1, fontWeight: 'bolder' }}>
                    Route: <strong style={{ color: 'darkblue' }}>{route}</strong>
                </h5>
                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1, marginLeft: '1%', fontWeight: 'bolder' }}>
                    Order Taken Date: <strong style={{ color: 'darkred' }}>{orderdate && new Date(orderdate).toLocaleDateString('en-GB')}</strong>
                </h5>
                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1, marginLeft: '1%', fontWeight: 'bolder' }}>
                    Order Taken By: <strong style={{ color: 'darkmagenta' }}>{orderTakenby}</strong>
                </h5>
            </div>
            <div className="flex justify-end">
                <div style={{ marginRight: '10px' }}>
                    <input
                        className="shadow text-gray-700 leading-tight"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        style={{
                            width: isFocused ? '300px' : '200px',
                            height: '40px',
                            border: '1px solid #ccc',
                            borderRadius: '15px',
                            padding: '0 20px',
                            transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                            outline: 'none',
                            borderColor: isFocused ? 'darkcyan' : '#ccc',
                            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                            marginTop: '-10px'
                        }}
                    />
                </div>
                <div className="w-1/4 mr-2" style={{ marginTop: '-10px', marginLeft: '2px' }}>
                    <Select
                        value={selectedTrip}
                        onChange={handleTripChange}
                        options={tripOptions}
                        placeholder="Select Trip"
                        isSearchable
                        styles={{
                            menu: (provided) => ({
                                ...provided,
                                zIndex: 1301,
                            }),
                        }}
                    />
                </div>
                <Button
                    style={{
                        backgroundColor: '#C9E9D2',
                        color: 'black',
                        height: '36px',
                        marginTop: '-10px',
                        marginLeft: '5px'

                    }}
                    onClick={handleRefreshClick}
                    className="linkcolor"
                >
                    <span>Refresh</span>
                </Button>

                <Button
                    style={{
                        backgroundColor: '#F8E8EE',
                        color: 'black',
                        height: '36px',
                        marginTop: '-10px',
                        marginLeft: '5px'

                    }}
                    onClick={handleExportExcel}
                    className="linkcolor"
                >
                    <span>Excel</span>
                </Button>
                <Button
                    style={{
                        backgroundColor: '#E8F3D6',
                        color: 'black',
                        height: '36px',
                        marginTop: '-10px',
                        marginLeft: '5px'

                    }}
                    onClick={handlePrint}
                    className="linkcolor"
                >
                    <span>Print</span>
                </Button>

            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '540px', overflowY: 'auto', marginTop: '0.20%' }}>

                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: 'whitesmoke', width: '2500px' }}>
                            <TableRow>
                                {columnOrder.map((col, index) => (
                                    <TableCell
                                        key={index}
                                        style={{
                                            padding: '3px',
                                            cursor: 'move',
                                            color: '#9D0B28',
                                            fontWeight: 'bold',
                                            textTransform: 'uppercase',
                                            fontSize: '11.5px',
                                            textAlign: [
                                                'UOM(kgs)',
                                                'Bundle',
                                                'Pieces',
                                                'QTY(No.Pieces)',
                                                'Total QTY(kgs)'
                                            ].includes(col) ? 'right' : 'left',

                                        }}
                                        draggable
                                        onDragStart={(e) => handleDragStart(e, index)}
                                        onDragOver={handleDragOver}
                                        onDrop={(e) => handleDrop(e, index)}
                                    >
                                        {col}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Array.isArray(processedData) && processedData.length > 0 ? (
                                processedData.map((rowData, index) => {
                                    // Check if this is the first item or if the productCategory and OrderTypeName are different from the previous item
                                    const showProductCategory = index === 0 || rowData.productCategory !== sortedData[index - 1].productCategory;
                                    const showOrderTypeName = index === 0 || rowData.OrderTypeName !== sortedData[index - 1].OrderTypeName;
                                    const showCategory = index === 0 || rowData.category !== data[index - 1].category;
                                    const showCustomerId = index === 0 || rowData.CustomerId !== data[index - 1].CustomerId;

                                    const showsaleremarks = index === 0 || rowData.saleremarks !== data[index - 1].saleremarks;

                                    const isOrderTypeName = rowData.OrderTypeName && rowData.OrderTypeName.includes('Total');
                                    const isGrandTotal = rowData.OrderTypeName === 'Grand Total';

                                    const rowValues = {
                                        'SL': index + 1,
                                        'Order Type': showOrderTypeName ? rowData.OrderTypeName || '' : '',
                                        'PDT Category': showProductCategory ? rowData.productCategory || '' : '',
                                        'Category': showCategory ? rowData.category || '' : '',
                                        'Code': rowData.itemCode || '',
                                        'Item': rowData.item || '',
                                        'Kilogram': rowData.kilogram || '',
                                        'Bundle': rowData.bundle || '',
                                        'Pieces': rowData.pieces || '',
                                        'Quantity': rowData.quantity || '',
                                        'Total Kilogram': rowData.totalkilogram || '',
                                        'Active Customers': showCustomerId ? rowData.CustomerId || '' : '',
                                        'Sale Remarks': showsaleremarks ? rowData.saleremarks || '' : '',
                                    };

                                    const isHighlightedRow =
                                        rowData.OrderTypeName?.includes('Total') || rowData.OrderTypeName === 'GRAND Total';

                                    return (
                                        <React.Fragment key={index}>
                                            {/* Main Row */}
                                            <TableRow
                                                style={{
                                                    backgroundColor: isHighlightedRow ? '#F5EFE3' : 'inherit',
                                                }}
                                            >
                                                {Object.keys(rowValues).map((key) => (
                                                    <TableCell
                                                        key={key}
                                                        sx={{
                                                            fontSize: '12.5px',
                                                            padding: '5px',
                                                            // textAlign: 'left',
                                                            textAlign: ['Kilogram', 'Bundle', 'Pieces', 'Quantity', 'Total Kilogram', 'Active Customers'].includes(key) ? 'right' : 'left',
                                                            width: '20px',

                                                        }}
                                                    >
                                                        {rowValues[key]}
                                                    </TableCell>
                                                ))}
                                            </TableRow>


                                        </React.Fragment>
                                    );
                                })
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={12} sx={{ textAlign: 'center' }}>
                                        No data available.
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                        {/* Render Grand Total in Footer */}
                        <TableFooter style={{ padding: '5px' }}>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[15, 25, 50, 100, 150, 250, 350, 500]}
                                    count={searchfilteredData.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handlePageChange}
                                    onRowsPerPageChange={handleRowsPerPageChange}
                                />
                            </TableRow>
                        </TableFooter>

                    </Table>
                </TableContainer>
            </div>



            <Modal open={showModal} className={showModal ? 'notification-modal' : ''}>
                <div className="fixed inset-0 flex items-start justify-center z-10 ">
                    <div className="bg-green-100  p-6 rounded-lg shadow-lg" style={{ width: '1000px', maxHeight: '80vh', overflowY: 'auto', overflowX: 'auto' }}>
                        <div className="flex justify-end mt-2">
                            <button className="close-button md:static md:mr-2" onClick={closeModal} style={{ marginTop: '-20px', color: 'black' }}>
                                <Tooltip title="Close">
                                    <FaTimes />
                                </Tooltip>
                            </button>
                        </div>
                        <h4 style={{ fontFamily: 'Times New Roman', textAlign: 'center', color: 'teal', fontWeight: 'bolder' }}>Ordered Items</h4>
                        <div className="used-items-container">
                            <TableContainer component={Paper}>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Sl.No</th>
                                            <th>Name</th>
                                            <th>BagWeight</th>
                                            <th>Qty</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedCustomerData && selectedCustomerData.map((item, index) => (
                                            <tr key={index}>
                                                <td className="px-4 py-2 border-r">{index + 1}</td>
                                                <td className="px-4 py-2 border-r">{item.item}</td>
                                                <td className="px-4 py-2 border-r">{item.weightage}</td>
                                                <td className="px-4 py-2 border-r">{item.quantity}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </TableContainer>
                        </div>
                    </div>
                </div>
            </Modal>
        </div >
    );
}

export default RouteOrderlistReport;

